import { render } from "./ComplianceView.vue?vue&type=template&id=f2a641f0"
import script from "./ComplianceView.vue?vue&type=script&lang=js"
export * from "./ComplianceView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__